<div class='add-jobs-dialog'>

  <h2 mat-dialog-title>Create Job</h2>

  <mat-dialog-content>
    <form [formGroup]='addJobForm' autocomplete='off' data-cy='add-job-form'>
      @if (mode === 0) {
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput formControlName='name' maxlength='255'>
          @if (addJobForm.controls['name']?.errors?.required) {
            <mat-error>
              Name is required
            </mat-error>
          }
          @if (addJobForm.controls['name']?.errors?.minlength) {
            <mat-error>
              Name must be at least 3 characters
            </mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field>
        <mat-label>Job Type</mat-label>
        <mat-select formControlName='jobTaskTemplateName'>
          @for (jobTaskTemplateName of jobTaskTemplateNameArray(); track jobTaskTemplateName) {
            <mat-option [value]='jobTaskTemplateName'>
              {{ jobTaskTemplateName }}
            </mat-option>
          }
        </mat-select>
        @if (addJobForm.controls['jobTaskTemplateName']?.errors?.required) {
          <mat-error>
            Job type is required
          </mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button (click)='close()'>Close</button>
    <button mat-raised-button color='primary' (click)='save()'>Save</button>
  </mat-dialog-actions>

</div>
